import { render, staticRenderFns } from "./DesignPaperLandingPage.vue?vue&type=template&id=e3d35dc8&scoped=true&"
import script from "./DesignPaperLandingPage.vue?vue&type=script&lang=js&"
export * from "./DesignPaperLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DesignPaperLandingPage.vue?vue&type=style&index=0&id=e3d35dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d35dc8",
  null
  
)

export default component.exports